import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { StyledIconBase } from '@styled-icons/styled-icon';
export var EllipsisHorizontal = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var attrs = {
    "fill": "currentColor",
    "xmlns": "http://www.w3.org/2000/svg"
  };
  return /*#__PURE__*/React.createElement(StyledIconBase, _extends({
    iconAttrs: attrs,
    iconVerticalAlign: "middle",
    iconViewBox: "0 0 512 512"
  }, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 256,
    r: 48
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 416,
    cy: 256,
    r: 48
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 96,
    cy: 256,
    r: 48
  }));
});
EllipsisHorizontal.displayName = 'EllipsisHorizontal';
export var EllipsisHorizontalDimensions = {
  height: 512,
  width: 512
};